import cx from 'classnames';
import React from 'react';
import { getIconByType } from '../../helpers/getIconsByType/getIconsByType';
import { NotificationType } from '../../model/types/NotificationType';
import style from './NotificationContent.module.scss';

interface Props {
  type: NotificationType;
  title?: string;
  message: string;
}

export const NotificationContent = ({ type, title, message }: Props) => (
  <div className={style.main} data-testid={`notification-${type}`}>
    <div className={cx(style.icon, style[type])}>{getIconByType(type)}</div>
    <div className={style.mainContent}>
      {title && <strong data-testid={`notification-title`}>{title}</strong>}
      <p data-testid={`notification-message`}>{message}</p>
    </div>
  </div>
);
